import * as angular from 'angular';
import template from './topDefectsGraph.tpl.html';
import controller from './topDefectsGraph.controller';

export default angular.module('aps.directive.topDefectsGraph', [controller])
  .directive('apsTopDefectsGraph', topDefectsGraphDef)
  .name;

function topDefectsGraphDef() {
  return {
    restrict: 'E',
    template: template,
    replace: true,
    controller: 'TopDefectsGraphCtrl',
    controllerAs: 'vm',
    bindToController: true,
    scope: {
      defects: '=',
      defectSelected: '=',
      showIfEmpty: '='
    },
    link: function ($scope: any, elm: any, attrs: any) {
      $scope.$watchCollection('vm.defects', function (newVal) {
        $scope.vm.setDefects(newVal);
      });
    }
  };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/controllers/dashboard/topDefectsGraph.directive.ts